import React from "react";
import { AppBar, Box, Paper, Toolbar, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { brand } from "../theme";
import Atras from "./atras";

// Ancho máximo del contenido de todas las secciones
export const CONTENT_WIDTH = 980;

const contentBox = {
  width: "100%",
  maxWidth: CONTENT_WIDTH,
  mx: "auto",
  px: { xs: 2, sm: 3 },
  boxSizing: "border-box",
};

// Encabezado de sección: fijo arriba, con el contenido alineado a la columna de 980px
export const PageHeader = ({ title, subtitle, back = true, leading, actions, children }) => (
  <AppBar
    position="sticky"
    color="inherit"
    elevation={0}
    sx={{
      top: 0,
      bgcolor: alpha(brand.sand, 0.88),
      backdropFilter: "blur(10px)",
      borderBottom: 1,
      borderColor: "divider",
    }}
  >
    <Toolbar disableGutters sx={{ ...contentBox, gap: 1.5, minHeight: { xs: 64, md: 72 } }}>
      {back && <Atras />}
      {leading}
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography variant="h6" component="h1" noWrap sx={{ fontWeight: 800, letterSpacing: "-0.01em" }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" noWrap>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions}
    </Toolbar>
    {children && <Box sx={{ ...contentBox, pb: 2 }}>{children}</Box>}
  </AppBar>
);

// Cuerpo de sección limitado a 980px; deja espacio para la BottomNav en móvil
export const PageContent = ({ children, sx }) => (
  <Box
    component="main"
    sx={{ ...contentBox, pt: { xs: 3, md: 4 }, pb: { xs: 12, md: 6 }, flexGrow: 1, ...sx }}
  >
    {children}
  </Box>
);

// Tarjeta blanca con borde suave para agrupar bloques dentro de una sección
export const Section = ({ title, description, children, sx }) => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 2.5, md: 3 },
      borderRadius: 4,
      border: 1,
      borderColor: "divider",
      ...sx,
    }}
  >
    {title && (
      <Box sx={{ mb: 2.5 }}>
        <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 800 }}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
      </Box>
    )}
    {children}
  </Paper>
);

// Contenedor de página completo (encabezado + contenido)
export const PageShell = ({ children }) => (
  <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", bgcolor: "background.default" }}>
    {children}
  </Box>
);
